import IconButton from '@mui/material/IconButton';
import { toastr } from 'react-redux-toastr';
import DeleteIcon from '@material-ui/icons/Delete';
import Modal from '@material-ui/core/Modal';
import { Button } from '@mui/material';
import API from '../../../../create/api';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

interface DeleteParcelProps {
  id: number;
  addToBalance: boolean;
  refreshParcel: () => void;
}

export default function DeleteParcel({ id, addToBalance, refreshParcel }: DeleteParcelProps) {
  const classes = useStyles();
  const [modalOpen, setModalOpen] = React.useState(false);

  const handleClose = () => {
    setModalOpen(false);
  };

  const Action = async () => {
    setModalOpen(false);
    await API.destroy(`${process.env.REACT_APP_API_SERVER}/parcels`, id).then((res) => {
      toastr.success('Success', `Parcel ${id} deleted`);
      refreshParcel();
    });
  };

  function addToCartButton() {
    return (
      <>
        <Modal
          aria-labelledby="spring-modal-title"
          aria-describedby="spring-modal-description"
          className={classes.modal}
          open={modalOpen}
          onClose={handleClose}
          closeAfterTransition
          BackdropProps={{
            timeout: 500,
          }}
        >
          <div className={classes.paper}>
            <h1 id="spring-modal-title">Add to Balance</h1>
            <p id="spring-modal-description">
              Do you want to delete APN {id}
              <br />
              <Button color="secondary" onClick={Action}>
                Yes
              </Button>
              <Button color="primary" onClick={handleClose}>
                No
              </Button>
            </p>
          </div>
        </Modal>

        <IconButton
          color="secondary"
          disabled={addToBalance}
          onClick={() => {
            setModalOpen(true);
          }}
        >
          <DeleteIcon />
        </IconButton>
      </>
    );
  }

  return addToCartButton();
}
